import React from 'react';
import {getUsers} from '../../api';
import {ThinkscapeTable} from '../common';
import {Link} from 'react-router-dom';
import Modal from '../common/Modal';
import {PrimaryDarkButton, SecondaryButton} from '../common/StyledButtons';
import UsageReportForm from './UsageReportForm';
import {Button} from '@material-ui/core';

export default function Users() {

    const [modalOpen, setModalOpen] = React.useState(false);

    const formatLink = (cell, row) =>
        <Link
            to={{
                pathname: `/users/${row.record._id.$oid}`,
                state: row.record,
            }}>
            {unescape(cell)}
        </Link>;

    return <>
        <Modal
            title="Email Usage Report"
            onClose={() => setModalOpen(false)}
            open={modalOpen}
            maxWidth="sm"
        >
            <UsageReportForm onClose={() => setModalOpen(false)}/>
        </Modal>
    <div className="content-box">
        <h1 className="section-header">
            <div className="section-title">Users</div>
        </h1>
        <div className="pull-right quizscape-action-btn">
            <PrimaryDarkButton onClick={() => setModalOpen(true)}>Get Usage Report</PrimaryDarkButton>
        </div>
        <ThinkscapeTable
            itemName="users"
            hiddenFields={['actions']}
            getFieldsMapping={(user) => (
                {
                    platformUserId: user.platformUserId,
                    username: user.userName,
                    email: user.email,
                })
            }
            fetchRecords={(args) => getUsers({
                ...args,
            })}
            fieldsSettings={
                {
                    platformUserId: {
                        sortable: true,
                        fieldText: 'User ID',
                        formatData: (cell,row) => formatLink(cell, row)
                    },
                    username: {
                        sortable: true,
                        fieldText: 'Name',
                        formatData: (cell,row) => formatLink(unescape(cell), row)
                    },
                    email: {
                        sortable: true,
                        fieldText: 'Email',
                        formatData: (cell,row) => formatLink(unescape(cell), row)
                    },
                }
            }
        />
    </div> </>;
}